<script lang="ts">
	import { zenpassRoutes } from '$lib/utils/routing';
	import GotoButton from '$lib/components/atoms/GotoButton.svelte';
	import { _ } from 'svelte-i18n';
</script>

<GotoButton gotoRoute={zenpassRoutes.overview} gotoButtonText={$_('buttons.getStarted')} />